/**
 * Capital Region NY service-area ZIP allowlist.
 * Used to warn visitors whose address falls outside the area we serve.
 */
const ZIP_LIST = [
  // Albany
  "12201", "12202", "12203", "12204", "12205", "12206", "12207", "12208", "12209", "12210", "12211", "12212",
  // Colonie / Latham / Loudonville / Menands
  "12110", "12189", "12204", "12211",
  // Delmar / Slingerlands / Glenmont / Voorheesville / Clarksville
  "12054", "12159", "12077", "12186", "12041",
  // Guilderland / Altamont
  "12084", "12085", "12009", "12203",
  // Schenectady / Niskayuna / Scotia / Rotterdam
  "12301", "12302", "12303", "12304", "12305", "12306", "12307", "12308", "12309", "12345",
  // Troy / Brunswick / Wynantskill / Poestenkill / Averill Park / Cropseyville
  "12180", "12181", "12182", "12183", "12198", "12140", "12018", "12052",
  // Rensselaer / East Greenbush / Castleton / Schodack / Nassau
  "12144", "12061", "12033", "12063", "12123",
  // Cohoes / Waterford / Green Island / Watervliet / Mechanicville / Stillwater
  "12047", "12188", "12183", "12189", "12118", "12170",
  // Clifton Park / Halfmoon / Rexford / Ballston Lake / Burnt Hills / Round Lake / Malta
  "12065", "12118", "12148", "12019", "12027", "12151", "12020",
  // Ballston Spa / Saratoga Springs / Wilton / Gansevoort
  "12020", "12866", "12831", "12831",
  // Bethlehem / Ravena area
  "12143", "12158",
];

export const SERVICE_ZIPS: ReadonlySet<string> = new Set(ZIP_LIST);

/** True when the ZIP is empty (not provided) or inside the service area. */
export function isServiceZip(zip: string): boolean {
  const z = zip.trim();
  if (!z) return true;
  return SERVICE_ZIPS.has(z);
}
